import { configureStore } from '@reduxjs/toolkit'
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'

import appConfig from './Config'
import accountActivity from '@core/Areas/AccountActivity/Store'
import appHeader from '@core/Areas/AppHeader/Store'
import blackbook from '@core/Areas/Blackbook/Store'
import login, { setIsLoginShown } from '@core/Areas/Login/Store'
import modal, { closeModal, openModal } from '@core/Components/Modal/store'
import signUp from '@mobi/account/Areas/SignUp/Store/'
import toolbox from '@core/Areas/Toolbox/Store'
import navigation from '@core/Areas/Navigation/Store'
import meetings from '@core/Areas/Meetings/Store'
import raceCard from '@core/Areas/RaceCard/Store'
import settings from '@core/Areas/Settings/Store'
import skyVideoPlayer from '@core/Areas/SkyVideoPlayer/Store'
import quickDeposit from '@core/Areas/QuickDeposit/Store'
import deposit from '@mobi/account/Areas/Deposit/Store/deposit'
import tipping from '@core/Areas/Tipping/Store'
import features from '@core/State/FeatureFlags/Store'
import skyRaces from '@core/Areas/RaceCardSky/Store'
import kambi from '@core/Areas/KambiClient/Store'
import notifications from '@core/Areas/Notifications/Store'
import favouriteNumbers from '@core/Areas/FavouriteNumbers/Store'
import structuredSearch from '@core/Areas/StructuredSearch/Store'
import { betslip } from '@mobi/betslip/Store'
import { listenerMiddleware } from './listenerMiddleware'
import geoLocation from '@core/Areas/VenueMode/Store'

export const store = configureStore({
  reducer: {
    accountActivity,
    appConfig,
    appHeader,
    betslip,
    blackbook,
    deposit,
    login,
    meetings,
    features,
    modal,
    navigation,
    raceCard,
    settings,
    signUp,
    skyRaces,
    skyVideoPlayer,
    toolbox,
    quickDeposit,
    kambi,
    notifications,
    tipping,
    favouriteNumbers,
    structuredSearch,
    geoLocation,
  },
  devTools: !PRODUCTION,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          openModal.type,
          closeModal.pending.type,
          setIsLoginShown.type,
        ],
        ignoredPaths: ['modal.items', 'login.onLoginSuccessCallback'],
      },
    }).prepend(listenerMiddleware.middleware),
})

export const persistor = persistStore(store)

// Types
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
